<template lang="pug">
  .login-google
    div(id="buttonDiv")
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { jwtDecode } from 'jwt-decode'

// @ is an alias to /src
/* global google */
export default {
  name: 'LoginGoogle',
  data() {
    return {
      googleClientId: "60282691461-l7qpbcva3anh218me18ckeaev49ptsfb.apps.googleusercontent.com"
    };
  },
  mounted() {
    window.handleCredentialResponse = this.handleCredentialResponse;
    if (window.google && window.google.accounts) {
      this.initializeGoogleSignIn()
    } else {
      const script = document.createElement('script')
      script.src = "https://accounts.google.com/gsi/client"
      script.async = true
      script.defer = true
      script.onload = this.initializeGoogleSignIn
      document.head.appendChild(script)
    }
  },
  methods: {
    ...mapActions({
      loginGoogle: 'auth/loginGoogle'
    }),
    ...mapMutations({
      setLoading: 'globais/setLoading',
      setModalLogin: 'modais/setLogin',
    }),
    initializeGoogleSignIn() {
      google.accounts.id.initialize({
        client_id: this.googleClientId,
        callback: this.handleCredentialResponse
      });
      google.accounts.id.renderButton(
        document.getElementById("buttonDiv"),
        { theme: "outline", size: "large" }
      );
      google.accounts.id.prompt()
    },

    handleCredentialResponse(response) {
      this.setLoading(true)
      const token = response.credential

      try {
        const decodedToken = jwtDecode(token)
        this.loginGoogle(decodedToken)
        .then(resp => {
          this.setLoading(false)
          this.setModalLogin(false)
          this.$message({
            message: 'Login realizado com sucesso!',
            type: 'success'
          })
          localStorage.setItem('_linkdrive', `Bearer ${resp.token}`)
          const user = jwtDecode(resp.token)
          localStorage.setItem('user', JSON.stringify(user.data[0][0]))
          setTimeout(() => {
            location.reload()
          }, 1500)
        })
        .catch(err => {
          this.setLoading(false)
          this.$message.error(err)
        })

      } catch (error) {
        console.error("Erro ao decodificar o token:", error)
      }
    }
  }
}
</script>